import { apiClient } from './client';

export const fileApi = {
  uploadFile: async (file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/api/files/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    });
    return response.data;
  },

  deleteFile: async (fileId) => {
    const response = await apiClient.delete(`/api/files/${fileId}`);
    return response.data;
  },
};
